import { render, staticRenderFns } from "./Cryptoicon.vue?vue&type=template&id=055fa676&"
import script from "./Cryptoicon.vue?vue&type=script&lang=js&"
export * from "./Cryptoicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports